// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kpi_box_container {
    background-color: var(--bg-card);
    max-width: 100%;
    min-height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 16px 18px;
    gap: 10px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    transition: all var(--transition-fast);
    text-decoration: none;
    position: relative;
    overflow: hidden;
}

.kpi_box_container::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, var(--primary), var(--primary-50));
    opacity: 0;
    transition: opacity var(--transition-fast);
}

.kpi_box_container:hover {
    box-shadow: var(--shadow-md);
    border-color: var(--primary-50);
    transform: translateY(-1px);
    text-decoration: none;
}

.kpi_box_container:hover::after {
    opacity: 1;
}

.kpi_box_title {
    font-weight: 500;
    margin: 0;
    font-size: 12px;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.03em;
    line-height: 1.3;
}

.kpi_box_container p {
    margin: 0;
    color: var(--text-primary);
}

.kpi_box_container span {
    color: var(--text-secondary);
    font-size: 13px;
}

.kpi_box_datas {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 6px;
    flex-wrap: wrap;
}

.kpi_box_data {
    font-weight: 700;
    font-size: 22px;
    color: var(--text-primary);
    letter-spacing: -0.02em;
    line-height: 1.2;
}
`, "",{"version":3,"sources":["webpack://./src/components/DataComponents/KPI/KpiBox/KpiBox.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,+BAA+B;IAC/B,+BAA+B;IAC/B,sCAAsC;IACtC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,qEAAqE;IACrE,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,gBAAgB;AACpB","sourcesContent":[".kpi_box_container {\n    background-color: var(--bg-card);\n    max-width: 100%;\n    min-height: 90px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 16px 18px;\n    gap: 10px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    transition: all var(--transition-fast);\n    text-decoration: none;\n    position: relative;\n    overflow: hidden;\n}\n\n.kpi_box_container::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: linear-gradient(90deg, var(--primary), var(--primary-50));\n    opacity: 0;\n    transition: opacity var(--transition-fast);\n}\n\n.kpi_box_container:hover {\n    box-shadow: var(--shadow-md);\n    border-color: var(--primary-50);\n    transform: translateY(-1px);\n    text-decoration: none;\n}\n\n.kpi_box_container:hover::after {\n    opacity: 1;\n}\n\n.kpi_box_title {\n    font-weight: 500;\n    margin: 0;\n    font-size: 12px;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    line-height: 1.3;\n}\n\n.kpi_box_container p {\n    margin: 0;\n    color: var(--text-primary);\n}\n\n.kpi_box_container span {\n    color: var(--text-secondary);\n    font-size: 13px;\n}\n\n.kpi_box_datas {\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n.kpi_box_data {\n    font-weight: 700;\n    font-size: 22px;\n    color: var(--text-primary);\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
